/**
 * @voltxampere/ui — DHT11 humidity + temperature sensor variant (Sprint 43-6, placeholder)
 *
 * PLACEHOLDER. Single-wire digital humidity + temperature sensor.
 * Range 20-90 % RH (±5 %) and 0-50 °C (±2 °C). Real protocol
 * simulation lands Sprint 47+. Lower precision than DHT22.
 *
 * Reference: Aosong DHT11. Vcc 3-5.5 V, single-wire bidirectional
 * data line, 1 Hz sample rate.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorDht11 = {
    id: "dht11",
    nameTr: "DHT11 (Nem + Sıcaklık Sensörü, placeholder)",
    nameEn: "DHT11 (Humidity + Temperature Sensor, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "DHT11",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-dht11.js.map